const AI_PARSE_LOCK_PREFIX = "fk_ai_parse_lock_";

export function setAiParseLock(quoteId) {
  if (!quoteId) return;
  try {
    sessionStorage.setItem(AI_PARSE_LOCK_PREFIX + quoteId, String(Date.now()));
  } catch {
    /* ignore */
  }
}

export function clearAiParseLock(quoteId) {
  if (!quoteId) return;
  try {
    sessionStorage.removeItem(AI_PARSE_LOCK_PREFIX + quoteId);
  } catch {
    /* ignore */
  }
}

export function isAiParseLocked(quoteId) {
  if (!quoteId) return false;
  try {
    const ts = sessionStorage.getItem(AI_PARSE_LOCK_PREFIX + quoteId);
    if (!ts) return false;
    const age = Date.now() - parseInt(ts, 10);
    if (age > 60000) {
      sessionStorage.removeItem(AI_PARSE_LOCK_PREFIX + quoteId);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

/** Extract bare email from a From header. */
export function emailFromHeader(fromHeader) {
  if (!fromHeader || typeof fromHeader !== "string") return "";
  const f = fromHeader.trim();
  if (f.includes("<")) {
    const inner = f.split("<")[1]?.split(">")[0];
    return (inner || "").trim().toLowerCase();
  }
  return f.replace(/["']/g, "").trim().toLowerCase();
}

export function domainFromEmail(email) {
  if (!email || typeof email !== "string") return "";
  const at = email.lastIndexOf("@");
  if (at === -1) return "";
  return email.slice(at + 1).trim().toLowerCase();
}

/**
 * Customer-authored ≈ message not from the monitored inbox domain (operator reply domain).
 */
export function isLikelyCustomerMessage(fromHeader, monitoredInboxEmail) {
  const addr = emailFromHeader(fromHeader);
  if (!addr) return false;
  const msgDom = domainFromEmail(addr);
  const inbox = (monitoredInboxEmail || "").trim().toLowerCase();
  const inboxDom = domainFromEmail(inbox);
  if (!inboxDom) return true;
  return msgDom !== inboxDom;
}

export function stripHtmlToText(html) {
  if (!html || typeof html !== "string") return "";
  return html
    .replace(/<style[\s\S]*?<\/style>/gi, " ")
    .replace(/<script[\s\S]*?<\/script>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/** Map raw Gmail API message from fetchEmailThread to a picker row. */
export function mapThreadMessageForPicker(m) {
  const from = m?.headers?.from || "";
  const bodyHtml = m?.body || "";
  const text = stripHtmlToText(bodyHtml);
  return {
    id: m?.id,
    from,
    fromEmail: emailFromHeader(from),
    bodyText: text,
    preview: text.length > 60 ? `${text.slice(0, 60)}…` : text,
    internalDate: m?.internalDate ? parseInt(m.internalDate, 10) : 0,
  };
}
